<template>
  <v-col :cols="cols" style="padding: 3px">
    <v-hover>
      <v-card
        slot-scope="{ hover }"
        class="card-outter"
        :class="`${clickable && hover? 'cursor-pointer' : ''}`"
        :elevation="clickable && hover? 12:2"
        color="color-2"
        :min-height="height"
      >
        <v-card-title>
          {{name}}
        </v-card-title>
        <v-card-text>
          <slot name="info"/>
        </v-card-text>
        <v-card-actions class="card-bottom-info">
          <slot name="bottom-info"/>
        </v-card-actions>
        <v-card-actions class="card-actions">
          <slot name="actions"/>
        </v-card-actions>
      </v-card>
    </v-hover>
  </v-col>
</template>
<script>
export default {
  props: ['name', 'loading', 'cols', 'clickable', 'height'],
  data: () => ({
  }),
}
</script>
<style lang="scss" scoped>
.shadow {
  text-shadow: 1px 1px #000;
}
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.card-bottom-info {
  position: absolute;
  bottom: 0;
  margin-bottom: 50px;
  width: 100%;
}
</style>
